import { Link } from 'react-router-dom';
import {
  ORDER,
  STORY,
  NUTRITION,
  SUPPORT,
  PRIVACY_POLICY,
  TERMS_CONDITIONS,
} from '../../../constants';
import { BrandButton } from '@/components/Buttons/BrandBtn/BrandBtn';
import { ToggleList } from '@/components/Lists/ToggleList/ToggleList';

const Footer = () => {
  const isPreRelease = import.meta.env.VITE_ENVIRONMENT == 'pre_release';
  const currentYear = new Date().getFullYear();
  const footerLinks = [
    <FooterLink to={ORDER}>Order</FooterLink>,
    <FooterLink to={STORY}>Our Story</FooterLink>,
    <FooterLink to={NUTRITION}>Nutrition & Allergens</FooterLink>,
    <FooterLink to={SUPPORT}>Support</FooterLink>,
  ];

  return (
    <footer
      className={`w-full text-brand-cream ${!isPreRelease && 'shadow-[0_-1px_0_0_rgba(0,0,0,0.25)]'}`}
    >
      {/* UPPER SECTION: Main Navigation */}
      {!isPreRelease && (
        <>
          {/* MOBILE: Visible only below 'md' breakpoint */}
          {/* <div className="block text-xl text-text-heading md:hidden px-6 py-6">
            <ToggleList
              label="Explore"
              items={footerLinks}
              itemClassName="py-2"
            />
          </div> */}

          {/* WEB/DESKTOP: Visible only from 'md' breakpoint up */}
          {/* <nav className="hidden md:block max-w-screen-2xl mx-auto px-6 py-12 md:py-16 text-text-heading">
            <div className="flex flex-col items-center justify-center gap-y-8 md:flex-row md:gap-x-12 [&_a]:transition-colors! [&_a]:duration-300! [&_a]:bg-brand-burgundy/0! [&_a:hover]:bg-brand-burgundy/50! hover:[&_a]:rounded-md! [&_a]:py-2 [&_a]:px-4">
              <span className="font-bold text-2xl">Explore</span>
              {footerLinks}
            </div>
          </nav> */}
        </>
      )}

      {/* LOWER SECTION: Branding & Legal */}
      <div className="bg-brand-gold pt-8 pb-10">
        <div className="max-w-screen-2xl mx-auto flex flex-col items-center ">
          {/* Logo / Title Area */}
          <div className="relative flex h-[100px]!">
            <BrandButton alt className="p-0! text-brand-truffle!" />
          </div>

          {/* Copyright & Map Attribution */}
          <div className="flex flex-col items-center gap-y-1 text-brand-truffle/80 text-xs sm:text-sm font-medium">
            <div className="flex items-center flex-col gap-y-2">
              <span className="block">
                © {currentYear} all rights reserved.
              </span>
              <a
                href="https://www.openstreetmap.org/copyright"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-brand-truffle transition-colors"
              >
                Map data © OpenStreetMap contributors
              </a>
            </div>

            {/* Legal Links */}
            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-2">
              <Link to={PRIVACY_POLICY} className="hover:underline">
                Privacy Policy
              </Link>
              <span className="opacity-30">|</span>
              <Link to={TERMS_CONDITIONS} className="hover:underline">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

/**
 * Sub-component for consistent styling of main footer links
 */
const FooterLink = ({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) => (
  <Link to={to} className="font-light text-lg! tracking-tight">
    {children}
  </Link>
);

export default Footer;
